import { withNamespaces } from "react-i18next";
import { Col, Row } from "reactstrap";

import FunctionsTable from "./components/functions-table";

const FunctionsTab = () => (
    <Row>
        <Col xl="12">
            <FunctionsTable />
        </Col>
    </Row>
);

export default withNamespaces()(FunctionsTab);
